"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = __importDefault(require("./styles"));
var Toggle = function (_a) {
    var isHidden = _a.isHidden, style = _a.style, className = _a.className, initialValue = _a.initialValue, onChange = _a.onChange, isDisabled = _a.isDisabled;
    if (isHidden)
        return null;
    var _b = react_1.useState(!!initialValue), isOn = _b[0], setIsOn = _b[1];
    var classNames = (className || '') + " " + (isOn ? 'on' : '') + " " + (isDisabled ? 'disabled' : '');
    var handleChange = function () {
        if (isDisabled || !onChange)
            return;
        var nextIsOn = !isOn;
        setIsOn(nextIsOn);
        onChange(nextIsOn);
    };
    return react_1.default.createElement(styles_1.default, { style: style, className: classNames, onClick: handleChange });
};
exports.default = Toggle;
//# sourceMappingURL=index.js.map